__turbopack_context__.v({
  "back": "ErrorPage-module-scss-module__AZco5W__back",
  "btn": "ErrorPage-module-scss-module__AZco5W__btn",
  "btn-alt": "ErrorPage-module-scss-module__AZco5W__btn-alt",
  "btn-default": "ErrorPage-module-scss-module__AZco5W__btn-default",
  "btn-default-dark-bg": "ErrorPage-module-scss-module__AZco5W__btn-default-dark-bg",
  "btn-disabled": "ErrorPage-module-scss-module__AZco5W__btn-disabled",
  "btn-elite": "ErrorPage-module-scss-module__AZco5W__btn-elite",
  "btn-gold": "ErrorPage-module-scss-module__AZco5W__btn-gold",
  "btn-lg": "ErrorPage-module-scss-module__AZco5W__btn-lg",
  "btn-link": "ErrorPage-module-scss-module__AZco5W__btn-link",
  "btn-plat": "ErrorPage-module-scss-module__AZco5W__btn-plat",
  "btn-primary": "ErrorPage-module-scss-module__AZco5W__btn-primary",
  "btn-sm": "ErrorPage-module-scss-module__AZco5W__btn-sm",
  "btn-success": "ErrorPage-module-scss-module__AZco5W__btn-success",
  "btn-warning": "ErrorPage-module-scss-module__AZco5W__btn-warning",
  "disabled": "ErrorPage-module-scss-module__AZco5W__disabled",
  "main": "ErrorPage-module-scss-module__AZco5W__main",
  "message": "ErrorPage-module-scss-module__AZco5W__message",
  "questions": "ErrorPage-module-scss-module__AZco5W__questions",
  "reloadCta": "ErrorPage-module-scss-module__AZco5W__reloadCta",
});
